<script>import { Button, Modal, Dateformat, api, Grid, Search, IconSpinner } from "duo-kit";
import { navigate } from "duo-kit";
import { createEventDispatcher } from "svelte";
import { trackerusers } from "./store";
export let id = null;
let dispatch = createEventDispatcher();
let open = true;
let selected = [];
let filtered = [];
let loading = false;
trackerusers.load();

async function save() {
  let user_ids = selected.map(user => user.id);
  let team_id = id;
  await api.save({
    url: `/duocms/api/tracker/teamusers/${team_id}`,
    method: "put",
    data: user_ids
  });
  dispatch("saved");
  open = false;
} // async function load(){
//   team = (await api.load({url:`/duocms/api/tracker/teams/${id}`})).data
// }
// if(id) load()</script>
<Modal bind:open heading="Add Team Members" on:closed={()=> navigate("/pseteams/")} style="width:90%;max-width:1000px;">
  <div class="row">
    {#if loading}
      <p><IconSpinner />  Loading Users...</p>
    {:else}
      <div class="searchbox">
        <Search placeholder="Search Users" bind:data={$trackerusers} bind:filtered={filtered} />
      </div>
      <div style="height:400px">
        <Grid 
          rowheight={30} data={filtered} 
          bind:selected
          multiselect
          columns={[
            {label:"First Name",field:"first_name",width:4},
            {label:"Surname",field:"surname",width:3},
            {label:"Email",field:"email",width:5},
            {label:"Valid To",field:"valid_to",width:2},
            {label:"Status",field:"status",width:3},
          ]}
        >
          <div slot="row" let:item>
            <div class="cell" style="flex:4">{item.first_name}</div>
            <div class="cell" style="flex:3">{item.surname}</div>
            <div class="cell" style="flex:5">{item.email}</div>
            <div class="cell" style="flex:2"><Dateformat date={new Date(item.valid_to)} /></div>
            <div class="cell" style="flex:3">{item.status}</div>
          </div>
          <div slot="footer" let:data>
            {filtered.length!=$trackerusers.length ? filtered.length+" of " : ""}{$trackerusers.length} Users
          </div>
        </Grid>
      </div>
    {/if}
  </div>
  <div slot="toolbar">
    <div class="pull-right">
      <Button mode="default" on:click={()=> open = false}>Cancel</Button>
      <Button mode="primary" on:click={save} disabled={!selected.length}>Add Selected ({selected.length})</Button>
    </div>
  </div>
</Modal>